import React from 'react';
import Header from '../../layout/Header'
import MobileNav from '../../layout/MobileNav'
import DataLegend from '../../components/open-meteo/DataLegend';
import HowRatingsWork from '../../components/open-meteo/HowRatingsWork'
import {Helmet} from "react-helmet";

const Info = () => {

  return (
    <>
        <Helmet>
            <title>Info | Oreca Pro</title>
            <link rel="canonical" href={window.location.href} />
        </Helmet>
        <Header />
        <MobileNav />
        <div className="py-[80px] px-5 max-w-[1100px] mx-auto">
            <h1 className='text-2xl font-semibold mb-2 md:mt-8'>Info</h1>
             <p className='text-custom-light-grey'>Information about how ratings and colors work.</p>
            
            <div className="bg-custom-charcoal border border-custom-light-blue/30 rounded-lg p-6 my-8">
                <h2 className="text-lg font-semibold text-custom-light-blue mb-3">Privacy & Personalization</h2>
                <div className="space-y-3 text-custom-light-grey">
                    <p>
                        <strong className="text-white">Your spots are private:</strong> All spots you create and save are completely private to your account. Other Oreca Pro members cannot see your saved locations.
                    </p>
                    <p>
                        <strong className="text-white">Ratings are personalized:</strong> The condition ratings you see are calculated based on the ideal conditions you set for each spot. Different users may see different ratings for the same location depending on their personal preferences.
                    </p>
                </div>
            </div>

            <DataLegend />
            <HowRatingsWork />
        </div>
    </>
  );
};

export default Info;
